// ============================================================================
// OBT F3 — İnceleme / karar enum etiketleri (paket-yerel)
// ============================================================================
// KAYNAK: backend/modules/obt/enums.py. Burada YENİ enum değeri türetilmez;
// yalnız backend'de GERÇEKTEN var olan değerler Türkçeleştirilir. Bilinmeyen
// değer geldiğinde ekran çökmemeli — `labelFor` güvenli fallback döndürür.
// ============================================================================

/** Cevap yaşam döngüsü (obt_response.status). */
export const RESPONSE_STATUS_LABELS = Object.freeze({
  draft: 'Taslak',
  submitted: 'İnceleme bekliyor',
  revision_requested: 'Revizyon istendi',
  resubmitted: 'Yeniden gönderildi',
});

/**
 * İnceleme kademesi durumu (obt_response.review_state).
 * NULL = gönderilmiş, henüz inceleme başlamamış → 'submitted' etiketiyle eşdeğer.
 */
export const REVIEW_STATE_LABELS = Object.freeze({
  bm_review: 'BM incelemesinde',
  bm_revision_requested: 'BM revizyon istedi',
  bm_approved: 'BM onayladı',
  bm_rejected: 'BM reddetti',
  my_review: 'MY incelemesinde',
  my_revision_requested: 'MY geri gönderdi (BM)',
  my_approved: 'MY onayladı',
  director_review: 'Müdür incelemesinde',
  director_selected: 'Müdür dahil etti',
  director_rejected: 'Müdür çıkardı',
  director_postponed: 'Müdür erteledi',
  completed: 'Tamamlandı',
});

/** Filtre-dışı park önerisi durumu (obt_suggested_park.status). */
export const SUGGESTED_PARK_STATUS_LABELS = Object.freeze({
  pending_bm_review: 'BM incelemesi bekleniyor',
  accepted: 'Onaylandı',
  rejected: 'Reddedildi',
});

/** Cevap yaşam-döngüsü OLAYI (obt_response_revision.event) — geçmiş kaydı. */
export const REVISION_EVENT_LABELS = Object.freeze({
  submitted: 'Gönderildi',
  revision_requested: 'Revizyon istendi',
  resubmitted: 'Yeniden gönderildi',
});

/** İnceleme aksiyonu (obt_review_action.action) — "kim ne yaptı" log satırı. */
export const REVIEW_ACTION_LABELS = Object.freeze({
  bm_review_started: 'incelemeye başladı',
  bm_approved: 'onayladı',
  bm_revision_requested: 'revizyon istedi',
  bm_rejected: 'reddetti',
  bm_note: 'not ekledi',
  my_review_started: 'incelemeye başladı',
  my_approved: 'onayladı',
  my_revision_requested: 'geri gönderdi',
  sent_to_director: 'Müdüre gönderdi',
  director_selected: 'nihai listeye dahil etti',
  director_rejected: 'listeden çıkardı',
  director_postponed: 'erteledi',
  suggested_park_approved: 'park önerisini onayladı',
  suggested_park_rejected: 'park önerisini reddetti',
  decision_finalized: 'kararı kesinleştirdi',
});

/** Karar seti durumu (obt_decision_set.status). */
export const DECISION_SET_STATUS_LABELS = Object.freeze({
  draft: 'Taslak',
  finalized: 'Kesinleştirildi',
  superseded: 'Yeni sürümle değiştirildi',
});

/**
 * Nihai karar item değerleri (DIRECTOR_ITEM_DECISIONS).
 * Backend YALNIZ bu üç değeri kabul eder.
 */
export const DECISION_VALUE = Object.freeze({
  SELECTED: 'selected',
  NOT_SELECTED: 'not_selected',
  POSTPONED: 'postponed',
});

export const DECISION_ITEM_LABELS = Object.freeze({
  selected: 'Nihai listeye dahil',
  not_selected: 'Nihai listeden çıkarıldı',
  postponed: 'Ertelendi',
});

/**
 * Karar kalemi park kaynağı (DecisionItemOut.scope_source). Backend değeri
 * `director_added` = müdürün aday kümesi dışından SONRADAN eklediği park.
 */
export const DIRECTOR_ADDED_SOURCE = 'director_added';

/** Kalem müdür-eklemesi mi? (scope_source director_added VEYA response_id yok). */
export function isDirectorAddedItem(item) {
  if (!item) return false;
  return item.scope_source === DIRECTOR_ADDED_SOURCE || item.response_id == null;
}

/** Karar arayüzünde kullanıcıya sunulan seçenekler (backend değerleriyle). */
export const DECISION_CHOICES = Object.freeze([
  { value: DECISION_VALUE.SELECTED, label: 'Dahil Et' },
  { value: DECISION_VALUE.NOT_SELECTED, label: 'Listeden Çıkar' },
  { value: DECISION_VALUE.POSTPONED, label: 'Karar Bekliyor' },
]);

const UNKNOWN_LABEL = 'Bilinmeyen durum';

/**
 * Güvenli etiket çözümü. Değer haritada yoksa (ör. yeni backend enum'u) ekran
 * çökmez; ham değeri değil sabit "Bilinmeyen durum" gösterir.
 * @param {Record<string,string>} map
 * @param {string|null|undefined} value
 */
export function labelFor(map, value) {
  if (value == null || value === '') return UNKNOWN_LABEL;
  return Object.prototype.hasOwnProperty.call(map, value) ? map[value] : UNKNOWN_LABEL;
}

/** review_state için özel: NULL → "İnceleme bekliyor" (henüz başlamadı). */
export function reviewStateLabel(value) {
  if (value == null || value === '') return 'İnceleme bekliyor';
  return labelFor(REVIEW_STATE_LABELS, value);
}

/** Karar item tonlaması (renk + metin birlikte; yalnız renkle ifade edilmez). */
export function decisionTone(value) {
  if (value === DECISION_VALUE.SELECTED) return 'success';
  if (value === DECISION_VALUE.NOT_SELECTED) return 'danger';
  if (value === DECISION_VALUE.POSTPONED) return 'warning';
  return 'muted';
}
